import { differenceInDays, isValid, parse } from 'date-fns';

/** Осталось полных дней до даты (отрицательное — просрочка). YYYY-MM-DD с API. */
export function getDeadlineDaysLeft(dateStr: string | null | undefined): number | null {
  if (!dateStr?.trim()) return null;
  try {
    const d = parse(dateStr.trim(), 'yyyy-MM-dd', new Date());
    if (!isValid(d)) return null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    d.setHours(0, 0, 0, 0);
    return differenceInDays(d, today);
  } catch {
    return null;
  }
}

export function getDayWordRu(n: number): string {
  const abs = Math.abs(n) % 100;
  if (abs >= 11 && abs <= 19) return 'дней';
  const last = abs % 10;
  if (last === 1) return 'день';
  if (last >= 2 && last <= 4) return 'дня';
  return 'дней';
}

/** «Осталось» / «Остался» — согласование с числом дней */
export function getRemainingHeadlineRu(daysLeft: number): string {
  const abs = Math.abs(daysLeft) % 100;
  if (abs >= 11 && abs <= 19) return 'Осталось';
  if (abs % 10 === 1) return 'Остался';
  return 'Осталось';
}

/**
 * Те же пороги, что у пилюли в ячейке дедлайна (ProjectDateCellContent).
 */
export type DeadlineUrgencyTier = 'complete' | 'urgent' | 'warning' | 'ok' | 'neutral' | 'default';

export function getDeadlineUrgencyTier(
  daysLeft: number | null,
  isCompleted: boolean
): DeadlineUrgencyTier {
  if (isCompleted) return 'complete';
  if (daysLeft === null || Number.isNaN(daysLeft)) return 'default';
  const isOverdue = daysLeft < 0;
  if (isOverdue || daysLeft <= 7) return 'urgent';
  if (daysLeft <= 14) return 'warning';
  if (daysLeft > 31) return 'ok';
  if (daysLeft > 14 && daysLeft < 31) return 'neutral';
  return 'default';
}

/**
 * Вариант оформления бейджа в комбо/меню (не ячейка таблицы):
 * нет даты / невалидная дата — «Нет дедлайна»; 14–30 дн. — белый фон как у спокойного блока;
 * просрочка и ≤7 — срочно; 8–13 — предупреждение; 31+ — «далеко» (ок).
 */
export type DeadlineRemainingBadgeStyle = 'no_deadline' | 'white' | 'urgent' | 'warning' | 'ok';

export function getDeadlineRemainingBadgeStyle(
  deadline: string | null | undefined,
  daysLeft: number | null
): DeadlineRemainingBadgeStyle {
  if (!deadline?.trim()) return 'no_deadline';
  if (daysLeft === null || Number.isNaN(daysLeft)) return 'no_deadline';
  if (daysLeft < 0 || daysLeft <= 7) return 'urgent';
  if (daysLeft <= 13) return 'warning';
  if (daysLeft <= 30) return 'white';
  return 'ok';
}
